import React from "react";
import USKbvMatchMinute from "../USKbvMatchMinute";
import { MobileOddCell, Mobile1x2Cell } from "./USMatchOddsCell";

export default function USMatchMobile({
  leagueName,
  matchDate,
  isLive,
  match,
  statusNum,
  liveScore,
  currentHomeScore,
  currentAwayScore,
  homeLogo,
  awayLogo,
  handicapValue,
  homeHandicapOdds,
  homeHandicapTrend,
  awayHandicapOdds,
  awayHandicapTrend,
  overUnderValue,
  overOdds,
  overTrend,
  underOdds,
  underTrend,
  homeEuropeOdds,
  homeEuropeTrend,
  awayEuropeOdds,
  awayEuropeTrend,
  instantDrawOdds,
  drawTrend,
  homeEuropeHalfOdds,
  homeEuropeHalfTrend,
  drawHalfOdds,
  drawHalfTrend,
  awayEuropeHalfOdds,
  awayEuropeHalfTrend,
  matchTimeText,
  TipsAiButton,
  OtherBetsButton,
}) {
  return (
    <div className="lg:hidden">
      <div className="rounded-2xl border-[0.88px] border-solid frost-border-faint bg-[var(--theme-bg)] p-2">
        <article className="rounded-2xl bg-[var(--theme-bg)] p-2">
          <header className="flex items-center justify-between gap-3">
            <div className="min-w-0 truncate text-[12px] font-semibold text-[var(--theme-text-muted)]">
              {leagueName}
            </div>
            <div className="flex items-center gap-2 text-[12px]">
              <span className="font-semibold text-[var(--theme-text-muted)]">{matchDate}</span>
              <span className="font-bold text-[var(--theme-text)]">
                {isLive ? (
                  <USKbvMatchMinute
                    matchTime={match?.matchTime}
                    status={statusNum}
                    liveScore={liveScore}
                    halfStartTime={match?.halfStartTime}
                    className="frost-text-trend-up"
                  />
                ) : (
                  matchTimeText
                )}
              </span>
            </div>
          </header>

          <div className="my-2 border-b border-[var(--theme-border)] pb-2">
            <div className="flex items-start justify-between gap-2">
              <div className="flex w-[calc(50%-26px)] min-w-0 items-start justify-end gap-2">
                <div className="min-w-0 flex-1 text-center text-[14px] font-semibold leading-snug text-[var(--theme-text)] [overflow-wrap:anywhere]">
                  {match?.homeName}
                </div>
                <div className="mt-0.5 h-6 w-6 shrink-0 overflow-hidden rounded-full bg-[var(--theme-text)] p-[2px]">
                  <img
                    className="h-full w-full rounded-full object-cover"
                    src={homeLogo || ""}
                    alt={match?.homeName}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>

              <div className="grid h-6 w-[34px] shrink-0 place-items-center self-center rounded-full bg-[var(--theme-accent)] text-[12px] font-bold text-[var(--theme-text)]">
                {isLive && currentHomeScore !== null && currentAwayScore !== null ? (
                  <span>
                    {currentHomeScore}-{currentAwayScore}
                  </span>
                ) : (
                  <span>Vs</span>
                )}
              </div>

              <div className="flex w-[calc(50%-26px)] min-w-0 items-start gap-2">
                <div className="mt-0.5 h-6 w-6 shrink-0 overflow-hidden rounded-full bg-[var(--theme-text)] p-[2px]">
                  <img
                    className="h-full w-full rounded-full object-cover"
                    src={awayLogo || ""}
                    alt={match?.awayName}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="min-w-0 flex-1 text-center text-[14px] font-semibold leading-snug text-[var(--theme-text)] [overflow-wrap:anywhere]">
                  {match?.awayName}
                </div>
              </div>
            </div>
          </div>

          <div className="mt-2 flex items-center gap-3">
            <div className="grid w-[calc(50%-26px)] grid-cols-2 gap-2">
              <MobileOddCell
                top={handicapValue}
                bottom={homeHandicapOdds}
                trendBottom={homeHandicapTrend}
              />
              <MobileOddCell top={null} bottom={awayHandicapOdds} trendBottom={awayHandicapTrend} />
              <MobileOddCell
                top={overUnderValue}
                bottom={overOdds}
                trendBottom={overTrend}
              />
              <MobileOddCell top="u" bottom={underOdds} trendBottom={underTrend} />
            </div>

            <div className="w-[46px] text-[11px] leading-[1.4] text-[var(--theme-text-muted)]">
              <div className="flex h-[54px] items-center justify-center">Chấp</div>
              <div className="flex h-[54px] items-center justify-center">Tài xỉu</div>
            </div>

            <div className="grid w-[calc(50%-26px)] grid-cols-2 gap-2">
              <MobileOddCell
                top={null}
                bottom={homeEuropeOdds}
                trendBottom={homeEuropeTrend}
                muted={homeEuropeOdds == null}
              />
              <MobileOddCell
                top={null}
                bottom={awayEuropeOdds}
                trendBottom={awayEuropeTrend}
                muted={awayEuropeOdds == null}
              />
              <MobileOddCell
                top={null}
                bottom={instantDrawOdds}
                trendBottom={drawTrend}
                muted={instantDrawOdds == null}
              />
              <MobileOddCell top={null} bottom={"--"} muted />
            </div>
          </div>

          <div className="mt-3">
            <div className="mb-1 text-center text-[12px] font-semibold leading-[1.5] frost-text-label-muted">
              1X2
            </div>
            <div className="grid grid-cols-3 gap-2">
              <Mobile1x2Cell
                label="H"
                bottom={homeEuropeOdds}
                trendBottom={homeEuropeTrend}
                muted={homeEuropeOdds == null}
              />
              <Mobile1x2Cell
                label="D"
                bottom={instantDrawOdds}
                trendBottom={drawTrend}
                muted={instantDrawOdds == null}
              />
              <Mobile1x2Cell
                label="A"
                bottom={awayEuropeOdds}
                trendBottom={awayEuropeTrend}
                muted={awayEuropeOdds == null}
              />
              <Mobile1x2Cell
                label="H"
                bottom={homeEuropeHalfOdds}
                trendBottom={homeEuropeHalfTrend}
                muted={homeEuropeHalfOdds == null}
              />
              <Mobile1x2Cell
                label="D"
                bottom={drawHalfOdds}
                trendBottom={drawHalfTrend}
                muted={drawHalfOdds == null}
              />
              <Mobile1x2Cell
                label="A"
                bottom={awayEuropeHalfOdds}
                trendBottom={awayEuropeHalfTrend}
                muted={awayEuropeHalfOdds == null}
              />
            </div>
          </div>

          <footer className="mt-2 flex justify-between gap-2">
            <TipsAiButton className="h-9 rounded-xl px-3 text-[13px] [background:linear-gradient(-45deg,#3b82f6,#8b5cf6)] border-none" />
            <OtherBetsButton className="frost-shadow-cta inline-flex h-9 w-[147px] items-center justify-center gap-2 rounded-xl bg-[linear-gradient(-45deg,var(--theme-primary),var(--theme-highlight))] px-3 text-[13px] font-semibold text-[var(--theme-text)] transition hover:-translate-y-[1px]" />
          </footer>
        </article>
      </div>
    </div>
  );
}
